import { CanDeactivateFn } from '@angular/router';
import type { CiNewPageComponent } from '../ci-new-page.component';

/** Covers sidebar links, Cancel, breadcrumbs and browser Back navigation. */
export const ciUnsavedChangesGuard: CanDeactivateFn<CiNewPageComponent> =
  (component) => component.canDeactivate();
